import {Dialog} from "./common";
import {rangeValue} from "../math/ranges";
import {range} from "../helpers/column_names";
import {parseChart} from "../math/writer";

export const action = "add-sparkline";

var types = [
	{id:"line", value:"Line"},
	{id:"spline", value:"Spline"},
	{id:"splineArea", value:"Spline Area"},
	{id:"area", value:"Area"},
	{id:"bar", value:"Bar"},
	{id:"pie", value:"Pie"}
];

export class DialogBox extends Dialog{
	$show(box, form){
		this.cell = this.view.getSelectedId();
		if(!this.cell)
			return false;

		var els = form.elements;
		this.view.$handleSelection = function(st, end, a, b){
			els.range.setValue(a+":"+b);
			return false;
		};

		els.range.setValue("");

		//sync state of dialog to data with  the selected cell
		let value = this.view.getCellValue(this.cell.row, this.cell.column);
		let data = parseChart(value);
		if (data){
			form.blockEvent();
			els.type.setValue(data.type);
			els.range.setValue(data.range);
			if (data.color){
				els.color_def.setValue(data.color);
				els.color_pos.setValue(data.color);		
			}
			if (data.negativeColor)
				els.color_neg.setValue(data.negativeColor);
			form.unblockEvent();
			renderPreview(this);
		}	

		els.range.focus();
	}
	$hide(){
		this.view.$handleSelection = null;
	}
	$init(){
		return {
			view: "ssheet-dialog",
			head:webix.i18n.spreadsheet.labels["sparkline-title"],
			move: true,
			position: "center",
			body:{
				view:"form", id: "form", visibleBatch:1, on:{ onChange : ()=> renderPreview(this) },  elements:[
					{view: "richselect", name:"type", label:webix.i18n.spreadsheet.labels["sparkline-type"], value:"line", labelPosition:"left", suggest:{
						view:  "ssheet-form-suggest",
						data:types
					}, on:{
						"onChange": typesChangeHandler
					}},
					{ view:"text", label:webix.i18n.spreadsheet.labels["sparkline-range"], name:"range"},
					{ view:"ssheet-colorpicker", label:webix.i18n.spreadsheet.labels["sparkline-color"], name:"color_def", id:"add_sparkline_color", value:"#6666FF", batch:"1"},
					{ view:"ssheet-colorpicker", label:webix.i18n.spreadsheet.labels["sparkline-positive"], name:"color_pos", value:"#6666FF", batch:"2"},
					{ view:"ssheet-colorpicker", label:webix.i18n.spreadsheet.labels["sparkline-negative"], name:"color_neg", value:"#FF6666", batch:"2"},
					{ view:"formlate", name:"preview", borderless:true, css:"webix_ssheet_preview", height:50 }
				]

			},
			on:{
				onSaveClick: () => okClick(this),
				onHideClick: () => this.close(),
				onCancelClick: () => this.close()
			}
		};
	}
	checkRange(text){
		if(text && range(text, this.view))
			return true;
		this.view.alert({text:webix.i18n.spreadsheet.labels["error-range"]});
	}
}

function renderPreview(dialog){
	var form = dialog.$dialog.getBody();
	var data = form.getValues();

	if (data.range && dialog.checkRange(data.range)){
		let i,
			values = rangeValue(dialog.view, data.range),
			config = sparkConfig(form);
		for(i =0 ; i < values.length; i++)
			values[i] = values[i]||0;
		form.elements.preview.setValue(webix.Sparklines.getTemplate(config)(values, { width:200, height: 40 }));
	}
}

function sparkConfig(form, config){
	var data = form.getValues();
	config = config || { type: data.type  };
	if (data.type === "bar"){
		config.color = data.color_pos;
		config.negativeColor = data.color_neg;
	}
	else if(form.elements.color_def.isVisible())
		config.color = data.color_def;

	return config;
}

function okClick(dialog){
	var form = dialog.$dialog.getBody();
	var config = sparkConfig(form, form.getValues());
	if (dialog.checkRange(config.range)){
		dialog.view.addSparkline(dialog.cell.row, dialog.cell.column, config);
		dialog.close();
	}
}




function typesChangeHandler(type){
	var form = this.getFormView();
	switch(type){
		case "pie":
			form.showBatch(3);
			break;
		case "bar":
			form.showBatch(2);
			break;
		default:
			form.showBatch(1);
	}
}